import { useEffect, useState } from "react";
import { Megaphone, X } from "lucide-react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

const TONE = {
  info: "border-primary/30 bg-primary/10",
  warning: "border-amber-500/30 bg-amber-500/10",
  success: "border-emerald-500/30 bg-emerald-500/10",
};

export function Announcements() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/announcements").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const dismiss = (id) => {
    setItems((x) => x.filter((a) => a.id !== id));
    api.post(`/announcements/${id}/dismiss`).catch(() => {});
  };
  if (!items.length) return null;
  return (
    <div className="space-y-2" data-testid="announcements">
      {items.map((a) => (
        <div key={a.id} className={cn("flex items-start gap-3 rounded-xl border p-4 fade-up", TONE[a.level] || TONE.info)} data-testid={`announcement-${a.id}`}>
          <Megaphone className="h-5 w-5 mt-0.5 shrink-0 text-primary" />
          <div className="flex-1 min-w-0">
            <p className="font-semibold">{a.title}</p>
            <p className="text-sm text-muted-foreground whitespace-pre-line">{a.message}</p>
          </div>
          <button onClick={() => dismiss(a.id)} className="text-muted-foreground hover:text-foreground" aria-label="Dispensar aviso" data-testid={`dismiss-announcement-${a.id}`}><X className="h-4 w-4" /></button>
        </div>
      ))}
    </div>
  );
}
